"use strict";
/**
 * 自助开通契约（P1-24）。
 *
 * 一个账号只有一次"注册开通"，所以状态是**单个对象**而不是列表。
 * 但每一步的进度要能被控制台逐条渲染：客户在等待时看到的
 * 是"第 5 步：填入起步内容"，而不是一个转圈 ——
 * 前者出问题时能直接说清楚卡在哪，后者只能问我们。
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROVISIONING_STEP_KEYS = void 0;
exports.PROVISIONING_STEP_KEYS = [
    'tenant',
    'membership',
    'site',
    'pages',
    'blocks',
    'trial',
    'activate',
    'host',
];
//# sourceMappingURL=provisioning.js.map